export default {
  isTopGun: true, // 是否为topGun版本
  showShareBtn: false, // 落地页是否展示分享按钮
  isSupportHurdle: false, // 是否支持通栏样式
  globalParams: {}
}
